"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var classnames_1 = require("classnames");

var styles_1 = require("@material-ui/core/styles");

var helpers_1 = require("@material-ui/core/utils/helpers");

var Paper_1 = require("@material-ui/core/Paper");

exports.styles = function (_a) {
  var palette = _a.palette,
      zIndex = _a.zIndex;
  var backgroundColorDefault = palette.type === 'light' ? palette.grey[100] : palette.grey[900];
  return styles_1.createStyles({
    // Styles applied to the root element.
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      // Prevent padding issue with the Modal and fixed position.
      boxSizing: 'border-box',
      zIndex: zIndex.appBar,
      flexShrink: 0,
      boxShadow: 'none'
    },
    // Styles applied to the root element if `position="fixed"`.
    positionFixed: {
      position: 'fixed',
      bottom: 0,
      left: 'auto',
      right: 0
    },
    // Styles applied to the root element if `position="absolute"`.
    positionAbsolute: {
      position: 'absolute',
      bottom: 0,
      left: 'auto',
      right: 0
    },
    // Styles applied to the root element if `position="sticky"`.
    positionSticky: {
      position: 'sticky',
      bottom: 0,
      left: 'auto',
      right: 0
    },
    // Styles applied to the root element if `position="static"`.
    positionStatic: {
      position: 'static'
    },
    // Styles applied to the root element if `position="relative"`.
    positionRelative: {
      position: 'relative'
    },
    // Styles applied to the root element if `color="default"`.
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: palette.getContrastText(backgroundColorDefault)
    },
    // Styles applied to the root element if `color="primary"`.
    colorPrimary: {
      backgroundColor: palette.primary.main,
      color: palette.primary.contrastText
    },
    // Styles applied to the root element if `color="secondary"`.
    colorSecondary: {
      backgroundColor: palette.secondary.main,
      color: palette.secondary.contrastText
    }
  });
};

var AppBarBottom = styles_1.withStyles(exports.styles)(function (_a) {
  var _b;

  var children = _a.children,
      classes = _a.classes,
      className = _a.className,
      _c = _a.color,
      color = _c === void 0 ? 'primary' : _c,
      _d = _a.position,
      position = _d === void 0 ? 'fixed' : _d,
      other = __rest(_a, ["children", "classes", "className", "color", "position"]);

  var positionClass = "position" + helpers_1.capitalize(position);
  var colorClass = "color" + helpers_1.capitalize(color);
  var computedClassName = classnames_1["default"](classes.root, classes[positionClass], (_b = {}, _b[classes[colorClass]] = color !== 'inherit', _b['mui-fixed'] = position === 'fixed' // Useful for the Dialog
  , _b), className);
  return React.createElement(Paper_1["default"], __assign({
    square: true,
    component: "footer",
    elevation: 4,
    className: computedClassName
  }, other), children);
});
exports["default"] = AppBarBottom;